<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="flex-1">
        <div class="text-4 font-weight-medium">Your Balance</div>
        <div class="mt-4 d-flex align-center justify-end text-5 px-md-6">
          <div>Total Assets:</div>
          <div class="ml-5 mt-0 d-flex align-baseline">
            <div>
              {{ totalAssets | denomFormat }}
            </div>
            <div class="darkgray--text text-6 ml-1 text-uppercase">
              {{ currentProject.staking.token }}
            </div>
            <v-divider vertical class="border-secondary ml-5 mr-5"></v-divider>
            <div>${{ totalAssetsUsd | currency }}</div>
            <div class="darkgray--text text-6 ml-1 text-uppercase">usd</div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Available</div>
            <div class="flex-3 text-right">Unbonding</div>
            <div class="flex-3 text-right">Withdrawable</div>
          </div>
          <div class="mt-4 d-flex align-center px-2 px-md-6 text-5">
            <div class="flex-2 text-uppercase">
              <div>
                <span> {{ availableBalance | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      availableBalance)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right text-uppercase">
              <div>
                <span> {{ unbondingBalance | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="text-right mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      unbondingBalance)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right text-uppercase">
              <div>
                <span> {{ withdrawableBalance | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="text-right mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      withdrawableBalance)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-2 px-md-6 py-2"
          >
            <div class="flex-2">Total Staked</div>
            <div class="flex-3 text-right">Locked Rewards</div>
            <div class="flex-3 text-right">Claimable Rewards</div>
          </div>
          <div class="mt-4 d-flex align-center px-2 px-md-6 text-5 text-uppercase">
            <div class="flex-2">
              <div>
                <span> {{ delegatedBalance | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      delegatedBalance)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right">
              <div>
                <span> {{ lockedReward | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="text-right mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      lockedReward)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
            <div class="flex-3 text-right">
              <div>
                <span> {{ claimableReward | denomFormat }}</span>
                <span class="darkgray--text text-6">
                  {{ currentProject.staking.token }}</span
                >
              </div>
              <div class="text-right mt-1 text-6 darkgray--text">
                <span class="font-weight-medium"
                  >${{
                    (getTokenPriceInUsd(currentProject.staking.token) *
                      claimableReward)
                      | currency
                  }}</span
                >
                <span class="ml-1">USD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-12 d-none d-md-block" style="width:160px">
        <div>
          <c-btn class="width-100" @click="goToTx('stake')" walletRequired
            >Stake</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4"
            is-secondary
            @click="goToTx('claim')"
            walletRequired
            >Claim</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4 text-center"
            is-secondary
            @click="goToTx('unbond')"
            walletRequired
            >Unbond</c-btn
          >
        </div>
        <div>
          <c-btn
            class="width-100 mt-4 text-center"
            is-secondary
            @click="goToTx('withdraw')"
            walletRequired
            >Withdraw</c-btn
          >
        </div>
      </div>
    </div>
    <div class="mt-10 d-block d-md-none">
      <div>
        <c-btn class="width-100" @click="goToTx('stake')" walletRequired
          >Stake</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4"
          is-secondary
          @click="goToTx('claim')"
          walletRequired
          >Claim</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4 text-center"
          is-secondary
          @click="goToTx('unbond')"
          walletRequired
          >Unbond</c-btn
        >
      </div>
      <div>
        <c-btn
          class="width-100 mt-4 text-center"
          is-secondary
          @click="goToTx('withdraw')"
          walletRequired
          >Withdraw</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      totalAssets: "staking/celer/totalAssets",
      availableBalanceState: "staking/celer/availableBalance",
      stakeBalances: "staking/celer/stakeBalances",
      rewards: "staking/celer/rewards",
    }),
    totalAssetsUsd() {
      return new BN(this.getTokenPriceInUsd(this.currentProject.staking.token))
        .multipliedBy(this.totalAssets)
        .toString();
    },
    delegatedBalance() {
      return Number(this.stakeBalances.result.delegated);
    },
    unbondingBalance() {
      return this.stakeBalances.result.unbonding;
    },
    withdrawableBalance() {
      return this.stakeBalances.result.withdrawable;
    },
    availableBalance() {
      return this.availableBalanceState?.result?.balance ?? 0;
    },
    lockedReward() {
      return this.rewards.result?.lockedReward ?? 0;
    },
    claimableReward() {
      return this.rewards.result?.claimableReward ?? 0;
    },
  },
  methods: {
    goToTx(type) {
      this.$router.replace({
        name: this.$route.name,
        query: { type, action: "tx" },
      });
    },
  },
};
</script>
